module.exports = __webpack_public_path__ + "img/icon_save_ball .51024002.png";